// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3volX","unreadBadge":"styles_unreadBadge__t-16a","modalContent":"styles_modalContent__3HoqK","modal":"styles_modal__1Qavo"};